<template lang='pug'>
DataProvider(:endpoint='endpoint', :filter='filter' ref='dataProvider' @success="$emit('updateResponse', $event)")
  div(slot-scope='{ data: response, error, loading }')
    LocalDataTable(
      v-if='response'
      :data='response'
      ref='dataTable'
      :title="$t('productivityTable.productivityList')"
      :customTotal='response.length || 0'
      :selectable='false'
      :loading='loading'
      customHeader
      :dataTable='response')
      template(slot='title-left')
        v-menu(v-model='showFilter' :close-on-content-click='false' :nudge-left='0' transition='scale-transition' origin="right top" offset-y left min-width='auto')
          template(v-slot:activator='{ on, attrs }')
            md-button(v-on='on' v-bind='attrs' class='md-simple md-github' style='float: right; height: 46px; margin-top: 17px;' @click='toggleShowFilter()')
              v-fab-transition
                v-icon(style='position: absolute; left: -5px;' v-show='showFilter') mdi-close
              v-fab-transition
                v-icon(style='position: absolute; left: -5px;' v-show='!showFilter') mdi-filter-variant
              div(style='margin:  8px 0 8px 33px;') {{$t('productivityTable.changeDate')}}
          v-date-picker(v-model='dateSelected' @input='showFilter = false' @change='updateDate' locale='pt-BR' color='#9c27b0')
      template(slot='footer' slot-scope='{ pagination }')
        v-row(style='justify-content: flex-end;')
          v-col(cols='auto')
            md-field
              label(for='pages') {{ $t('assistantsList.perPage') }}
              md-select(v-model='pagination.perPage' name='pages' )
                md-option(
                  v-for='item in pagination.perPageOptions',
                  :key='item',
                  :label='item',
                  :value='item')
                  | {{ item }}
      template(slot='cells' slot-scope='{ item }')
        md-table-cell(:md-label="$t('productivityTable.cpf')") {{ item.cpf }}
        md-table-cell(:md-label="$t('productivityTable.email')") {{ item.email }}
        md-table-cell(:md-label="$t('productivityTable.operator')") {{ item.operator }}
        md-table-cell(:md-label="$t('productivityTable.rules')") {{ item.rules }}
        md-table-cell(:md-label="$t('productivityTable.queues')") {{ item.memberQueue }}
        md-table-cell(:md-label="$t('productivityTable.hiddenQueues')") {{ item.hideQueue || '-' }}
        md-table-cell(:md-label="$t('productivityTable.registrationDate')") {{ item.registerDate }}
        md-table-cell(:md-label="$t('productivityTable.dateOfFirstCall')")  {{ item.firstAttendDate }}
        template(v-for='(currentColumn, i) in item.allAttendOperator')
          md-table-cell#dateValueId(:md-label="currentColumn.date ? formatDate(currentColumn.date) : 'Total'") {{ currentColumn.totalAttend || currentColumn.value || 0 }}
        md-table-cell(:md-label="$t('productivityTable.dateOfFirstCall')")  {{ '' }}
    div(v-if="error" style='color: #2c2c2c60; font-size: 20px; font-weight: 500; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);') {{$t('cardNoData.errorLoadingGraph')}}
</template>
<script>
import Pagination from '@/components/Pagination.vue'
import chatsList from '@/pages/data/chatsList'
import LocalDataTable from '@/components/LocalDataTable.vue'
import DataProvider from '@/components/DataProvider'
import ChatConversation from '@/components/ChatConversation'
import * as moment from 'moment'
import { selectedLocale } from '@/plugins/i18n'
// PARA INTERVALOS DINÂMICOS
// import { mapFields } from 'vuex-map-fields'
export default {
  components: {
    Pagination,
    LocalDataTable,
    DataProvider,
    ChatConversation
  },
  data () {
    return {
      channels: ['webclient', 'whatsapp', 'teams', 'facebook', 'telegram'],
      evaluation: [1, 0.8, 0.6, 0.4, 0.2, 0],
      intents: [],
      intentFilter: undefined,
      channelFilter: undefined,
      evaluationFilter: undefined,
      searchBarText: undefined,
      dialog: false,
      chatLoader: false,
      showFilter: false,
      // Chat List
      filter: {
        order: 'desc',
        orderBy: 'start_datetime',
        page: 0,
        perPage: 20
      },
      tableData: chatsList,
      searchedData: [],
      chatInfo: {},
      dateSelected: ''
    }
  },
  computed: {
    // PARA INTERVALOS DINÂMICOS
    // ...mapFields('reports', ['dateInterval']),
    endpoint () {
      return `${process.env.VUE_APP_REPORTS_BACKEND}/reports/productivityReport`
    }
  },
  methods: {
    // dataTransformer (response) {
    //   response.data.forEach(item => {
    //     if (!item._source.infos_user) item._source.info_user = {}
    //   })
    // },
    toggleShowFilter () {
      this.showFilter = !this.showFilter
    },
    endReason (item) {
      if (item._source.closed_by_operator) {
        return this.$t('productivityTable.attendant')
      } else if (item._source.closed_by_user) {
        return this.$t('productivityTable.user')
      } else if (item._source.expired_by_user_inactivity) {
        return this.$t('productivityTable.userInactivity')
      } else {
        return this.$t('productivityTable.operatorInactivity')
      }
    },
    // PARA INTERVALOS DINÂMICOS
    // updatedDate () {
    //   this.filter.from = this.dateInterval.timestamp1
    //   this.filter.to = this.dateInterval.timestamp2
    //   this.$refs.dataProvider.load()
    // },
    // PARA INTERVALOS DE 30 DIAS
    updateDate () {
      let datePicked = moment(this.dateSelected).format('YYYY-MM-DD[T]HH:mm:ss')
      let days30Before = moment(this.dateSelected).subtract(30, 'days').format('YYYY-MM-DD[T]HH:mm:ss')
      this.filter.from = days30Before
      this.filter.to = datePicked
      this.$refs.dataProvider.load()
    },

    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L')
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    fomartDuration (duration) {
      let minutes, seconds
      if (duration >= 1) {
        minutes = Math.floor(duration)
      }
      const fractionOfSeconds = Math.ceil(duration) - duration
      seconds = Math.round(fractionOfSeconds * 60)
      return `${minutes ? minutes + 'min' : ''}${seconds ? seconds + 's' : ''}`
    },
    mountDateTime (d, t, seconds) {
      return `${d}T${t}:${seconds}`
    },
    dateInitial () {
      let dateInt = {
        timestamp1: moment().subtract(4, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
        timestamp2: moment().endOf('day').format('YYYY-MM-DD')
      }

      return dateInt.timestamp2
    }
  },
  created () {
    // PARA INTERVALOS DINÂMICOS
    // this.dateInterval = {
    //   timestamp1: new Date(new Date(Date.now() - 604800000).setHours(0, 0)),
    //   timestamp2: new Date(new Date().setHours(23, 59))
    // }
    // this.filter.from = this.dateInterval.timestamp1
    // this.filter.to = this.dateInterval.timestamp2

    // PARA INTERVALOS DE 30 DIAS
    this.filter.to = moment().startOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    this.filter.from = moment().startOf('day').subtract(30, 'days').format('YYYY-MM-DD[T]HH:mm:ss')
    this.dateSelected = this.dateInitial()
    // let datePicked = new Date(this.mountDateTime(this.dateSelected, '23:59', '59'))
    // let other = new Date(this.mountDateTime(this.dateSelected, '00:00', '00'))
    // console.log(datePicked)
  }
  // watch: {
  //   PARA INTERVALOS DINÂMICOS
  //   dateInterval: {
  //     deep: true,
  //     handler (nV) {
  //       this.updatedDate()
  //     }
  //   }
  // }
}
</script>
<style lang='css'>
#custom-filter-input > .v-text-field .v-input__control {
  margin: auto;
}
</style>
